import { FadeUp, Overline } from "./Reveal";

export const SectionHeading = ({ overline, title, copy, className = "", testid }) => (
  <div className={className}>
    <FadeUp>
      <Overline>{overline}</Overline>
      <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl" data-testid={testid}>
        {title}
      </h2>
      {copy && <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted md:text-lg">{copy}</p>}
    </FadeUp>
  </div>
);
